/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-face-activated-add': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M18.75 2.5h-2.5V0H15v2.5h-2.5v1.25H15v2.5h1.25v-2.5h2.5V2.5zM7.187 6.875A1.563 1.563 0 108.75 8.438a1.55 1.55 0 00-1.563-1.563zm5.625 0a1.563 1.563 0 101.563 1.563 1.55 1.55 0 00-1.563-1.563zM5.625 12.5a5.081 5.081 0 008.75 0h-8.75zm11.762-3.75A7.5 7.5 0 1110 2.5V1.25A8.75 8.75 0 1018.75 10a9.194 9.194 0 00-.1-1.25h-1.262z"/>'
  }
})
